import { useContextSelector } from 'use-context-selector'

import { AuthContext } from '../contexts/Auth'
import { AuthContextProps } from '../types/Auth/context'

export function useAuth(): AuthContextProps {
  const isAuthenticated = useContextSelector(AuthContext, (cs) => cs.isAuthenticated)
  const tokens = useContextSelector(AuthContext, (cs) => cs.tokens)

  const signInByTokens = useContextSelector(AuthContext, (cs) => cs.signInByTokens)
  const signOut = useContextSelector(AuthContext, (cs) => cs.signOut)

  return { isAuthenticated, signInByTokens, signOut, tokens }
}
